module.exports = __webpack_public_path__ + "static/media/we3academy_gridexample_we3solutions.62432895.gif";